import { Component } from '@angular/core';
import { AdminMenuComponent } from './components/admin-menu/admin-menu.component';
import { RouterOutlet } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
    standalone: true,
    imports:[
        RouterOutlet,
        AdminMenuComponent,
    ],
    providers:[
        ConfirmationService
    ],
    selector: 'gig-adminpanel',
    templateUrl: './adminpanel.component.html',
    styleUrl: './adminpanel.component.scss'
})
export class AdminpanelComponent {}
